import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';
import { mountVersionGuard } from '@version-guard';
import App from './App';
import { I18nProvider } from './lib/i18n';
import './index.css';

// Ver comentario en admin-portal/src/main.tsx.
mountVersionGuard({
  portal: 'inspector-portal',
  appName: 'el inspector',
  policy: 'auto-when-idle',
});

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // El dashboard maneja sus propios refetchInterval; acá solo defaults
      // conservadores para no duplicar requests.
      staleTime: 3_000,
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <I18nProvider>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </QueryClientProvider>
    </I18nProvider>
  </StrictMode>,
);
